import { routes as adminRoutes } from "./admin";
import { routes as sharedRoutes } from "./shared";

export const routes = [...adminRoutes, ...sharedRoutes];
